module.exports = __webpack_public_path__ + "img/xls.03f68de4.png";